import {
    CONFIRMED_GET_FREQUENCIES,
    CONFIRMED_CREATE_FREQUENCY,
    CONFIRMED_DELETE_FREQUENCY,
    CONFIRMED_EDIT_FREQUENCY,
  } from "../types/FrequencyTypes";
  
  import {
    getFrequencies,
    createFrequency,
    updateFrequency,
    deleteFrequency,
    formatFrequencies,
  } from "../../services/FrequencyService";
  
  import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";
  
  // Get Frequency list
  export function getFrequencyAction(
    pagination = true,
    pageid = 0,
    search_by = "",
    search_keyword = "",
    sort_by = "",
    sort_order = ""
  ) {
    return async (dispatch) => {
      try {
        const response = await getFrequencies(
          pagination,
          pageid,
          search_by,
          search_keyword,
          sort_by,
          sort_order
        );
  
        if (response?.status === 200 && response.data?.status === "success") {
          const list = formatFrequencies(response.data.data);
          const num_rows = response.data.num_rows || 0;
  
          dispatch({
            type: CONFIRMED_GET_FREQUENCIES,
            payload: { list, num_rows },
          });
        } else {
          handleError("Failed to get Frequency");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to get Frequency");
      }
    };
  }
  
  // Delete
  export function deleteFrequencyAction(frequencyId) {
    return async (dispatch) => {
      try {
        await deleteFrequency(frequencyId);
        dispatch({
          type: CONFIRMED_DELETE_FREQUENCY,
          payload: { frequency_id: frequencyId },
        });
        handleSuccess("Frequency deleted successfully!");
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to delete Frequency");
      }
    };
  }
  
  // Create
  export function createFrequencyAction(frequencyData, navigate) {
    return async (dispatch) => {
      try {
        const response = await createFrequency(frequencyData);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formatted = formatFrequencies([response.data.data])[0];
          dispatch({
            type: CONFIRMED_CREATE_FREQUENCY,
            payload: formatted,
          });
          if (navigate) navigate("/frequency");
          handleSuccess("Frequency created successfully!");
        } else {
          showErrorAlert("Failed to create Frequency");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to create Frequency");
      }
    };
  }
  
  // Update
  export function updateFrequencyAction(frequencyData, frequencyId, navigate) {
    return async (dispatch) => {
      try {
        const payload = {
          ...frequencyData,
          frequency_id: frequencyId,
        };
  
        const response = await updateFrequency(payload);
  
        if (response?.status === 200 && response.data?.status === "success") {
          const formatted = formatFrequencies([response.data.data])[0];
          dispatch({
            type: CONFIRMED_EDIT_FREQUENCY,
            payload: formatted,
          });
          if (navigate) navigate("/frequency");
          handleSuccess("Frequency updated successfully!");
        } else {
          showErrorAlert("Failed to update Frequency");
        }
      } catch (error) {
        console.error(error);
        showErrorAlert("Failed to update Frequency");
      }
    };
  }
  